import {Link} from '@shopify/hydrogen';
import {formatDate} from '~/lib';
import navigation from '~/lib/navigation';
import {BlogEntity} from '~/types/BlogEntity';
import sanityConfig from '../../sanity.config';
import {PostCategories} from './elements/PostCategories';
import SanityImage from './media/SanityImage.client';

export function ChairliftChatCard({
  item,
  replaceHistoryOnClick,
}: {
  item: BlogEntity;
  replaceHistoryOnClick?: boolean;
}) {
  return (
    <div>
      <div className="aspect-square w-full bg-gray-100 rounded-[10px] lg:rounded-none">
        {(item.image?.asset?._ref ||
          (item.hero?.hero?.assetType === 'photo' &&
            item.hero?.hero?.photo?.heroImage?.asset?._ref)) && (
          <Link to={navigation.blogDetail.getPath(item.slug?.current ?? '')}>
            <SanityImage
              alt={item.title}
              dataset={sanityConfig.dataset}
              layout="responsive"
              objectFit="cover"
              projectId={sanityConfig.projectId}
              src={
                item.image?.asset?._ref ??
                (item.hero?.hero.assetType === 'photo' &&
                  item.hero.hero.photo?.heroImage?.asset?._ref)
              }
              className="rounded-[10px] lg:rounded-none object-cover"
              breakpoints={[
                [170, 170],
                [434, 434],
              ]}
            />
          </Link>
        )}
      </div>
      <Link to={navigation.blogDetail.getPath(item.slug?.current ?? '')}>
        <div className="text-16/22 lg:text-20/26 font-header font-bold mt-5 line-clamp-2 h-[44px] lg:h-[52px]">
          {item.title}
        </div>
      </Link>
      <div className="text-13/18 lg:text-16/20 font-header font-bold mt-2.5 md:mt-5 text-gray-400">
        {formatDate(item.publishDate ?? '').toUpperCase()}
      </div>
      <PostCategories
        className="flex mt-2.5"
        categories={item.categories}
        replaceHistoryOnClick={replaceHistoryOnClick}
        limit={2}
      />
    </div>
  );
}
